<template>
  <div class="lead-page-wrapper">
    <!-- Filigrane parcours (desktop uniquement, clippe pour ne pas creer de scroll horizontal) -->
    <div class="watermark-bg" aria-hidden="true">
      <i class="fas fa-motorcycle watermark"></i>
    </div>

    <!-- Header Section -->
    <v-container fluid class="header-section text-xs-center pt-5">
      <h1 class="display-2 font-weight-bold mb-3 primary--text mt-5 pt-5">
        Souscription <span class="title-text-shadow">2 Roues</span>
      </h1>
      <p class="subtitle">Plus simple. Plus rapide.</p>
    </v-container>

    <!-- Main Content Card -->
    <v-container class="margin-top">
      <AywaForm :id_association="id_association" :agentCodeFromUrl="agentCode" ref="form" />
    </v-container>

    <ParcoursMiniFooter v-if="!agentCode" />
  </div>
</template>

<script>
import AywaForm from './index.vue'; //Importation du formulaire de lead
import ParcoursMiniFooter from '../parcours_mini_footer.vue';

export default {
  name: 'LeadPage',
  props: {
    id_association: {
      type: String,
      required: false
    },
    agentCode: {
      type: String,
      required: false
    }
  },
  components: {
    AywaForm,
    ParcoursMiniFooter
  }
};
</script>

<style scoped>
.lead-page-wrapper {
  background: linear-gradient(180deg, #ffa50992 0%, #e0f7fa 30%, #ffffff 40%, #ffffff 100%);
  min-height: 100vh;
  margin-top: 3%;
  font-family: 'Roboto', sans-serif; /* Ensure clean font */
  position: relative;
}

/* Container clippant du filigrane, centre et max-width pour rester ancre au contenu sur grand ecran */
.watermark-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 1440px;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}
.watermark {
  position: absolute;
  right: -40px;
  bottom: 40px;
  font-size: 320px;
  opacity: 0.05;
  color: #2b2b2b;
  line-height: 1;
}

/* Header Text Color Override if Primary isn't dark enough */
.primary--text {
  color: #2b2b2b !important; /* Teal Darken 4 for header */
}
.margin-top {
  margin-top: 2%;
}
.title-text-shadow {
  color: #ffa409;
  text-shadow:
    0 0 2px #fff,
    0 0 1px #fff,
    0 0 1px #fff,
    0 0 1px #fff,
    0 0 1px #fff,
    0 0 1px #fff,
    0 0 1px #fff,
    0 1px 2px rgba(0, 0, 0, 0.3),
    0 3px 9px rgba(0, 0, 0, 0.1);
}

.subtitle {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
    font-weight: 400;
  color: #191919; /* Corresponds to grey--text text--darken-1 */
  font-size: 20px; /* Corresponds to subheading */
}

@media (max-width: 600px) {
  .watermark { display: none; }
  .header-section h1 {
    font-size: 28px !important;
    line-height: 1.2 !important;
    margin-top: 20px !important;
    padding-top: 20px !important;
  }
  .subtitle {
    font-size: 16px;
    padding: 0 15px;
  }
  .lead-page-wrapper {
    margin-top: 0;
  }
}
</style>
